import request from "@/utils/request";
import config from '@/config/index'
import enumObject from "@/utils/enum";
const GateWay = enumObject.providerConfig[config.projectName].gateway;
// 沃支付
export function WO_UnderOrderByMiddleware (data) {
  return request({
    url: GateWay + "/wo/pay",
    method: "post",
    data
  });
}
// 聚合
export function JH_UnderOrderByMiddleware (data) {
  return request({
    url: GateWay + "/newPay/api/H5Payment",
    method: "post",
    data
  });
}
// 银联支付
// export function YINLIAN_UnderOrderByMiddleware (data) {
//   return request({
//     url: GateWay +"/newPay/api/H5Payment",
//     method: "post",
//     data
//   });
// }
// // 银联支付
export function YINLIAN_UnderOrderByMiddleware (data) {
  return request({
    url: GateWay + "/unionPay/pay",
    method: "post",
    data
  });
}
// 银联支付
export function YINLIAN_UnderOrderByMiddlewareCard (data) {
  return request({
    url: GateWay + "/unionPay/monthlyPayment",
    method: "post",
    data
  });
}
// 银联补缴支付
export function YINLIAN_UnderOrderByMiddlewareBJ (data) {
  return request({
    url: GateWay + "/unionPay/mergeOrderPay",
    method: "post",
    data
  });
}
// 乐刷支付
export function LESHUA_UnderOrderByMiddleware (data) {
  return request({
    url: GateWay + "/leshua/pay",
    method: "post",
    data
  });
}
// 南京银行支付
export function NJCB_UnderOrderByMiddleware (data) {
  return request({
    url: GateWay + "/NJBank/Defray",
    method: "post",
    data
  });
}
// 农业银行银行下单
export function ABC_UnderOrderByMiddleware (data) {
  return request({
    url: GateWay + "/abc/unifiedOrder",
    method: "post",
    data
  });
}
//获取支付配置
export function Pay_GetConfig (data) {
  return request({
    url: GateWay + "/pay/getConfig",
    method: "post",
    data
  });
}
// 建行聚合支付(走中间件)
export function CCB_UnderOrderByMiddleware (data) {
  return request({
    url: GateWay + "/CCB/pay",
    method: "post",
    data
  });
}
//// 支付宝支付（中间件）
export function Alipay_UnderOrder (data) {
  return request({
    url: GateWay + "/Alipay/pay",
    method: "post",
    data
  });
}
//建行聚合支付 统一下单
export function CCB_UnderOrder (params) {
  return request({
    url: GateWay + "/CCBIS/ccbMain?CCB_IBSVersion=V6&" + params,
    method: "post"
  });
}

// 建行聚合支付
export function CCB_Payment (url) {
  return request({
    url: GateWay + "/CCBIS" + url,
    method: "get"
  });
}
//苏宁添加缴费记录
export function SNInsertData (data) {
  return request({
    url: GateWay + "/sn/InsertData",
    method: "post",
    data
  });
}
// 苏宁易付宝支付RSA加密
export function SNPayEncrypt (data) {
  return request({
    url: GateWay + "/pay/SNPayEncrypt",
    method: "post",
    data
  });
}
// 苏宁易付宝支付WAP
export function SNPayWAP (data) {
  return request({
    url: GateWay + "/pay/SNWAP",
    method: "POST",
    data
  });
}
//苏宁易付宝根据订单号和下单时间查询订单信息
export function querySNOrder (data) {
  return request({
    url: GateWay + "/pay/querySNOrder",
    method: "post",
    data
  });
}
